// extracted by mini-css-extract-plugin
export var section = "faq-module--section--8zL0M";
export var gridContainer = "faq-module--gridContainer--3gEF+";